import React from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'
import { QuestsContainer, H6QuestName } from './_Styled'
import LevelQuest from '../../../mini/LevelQuest/LevelQuest'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import QuestTooltip from '../Tooltip/QuestTooltip'
import { CoreChoiceMarker } from '../styles'
import { updateQuestPropertiesFromProgress } from '../../../../utils/levelquests'
import TargetDateIcon from '../../../mini/LevelQuest/TargetDateIcon/TargetDateIcon'
import { H5 } from '../../../styled/typography/typography'
import useIsActivityCourse from '../../../../hooks/useIsActivityCourse'
import TooltipContainer from '../../../styled/TooltipContainer'
import ReactTooltip from 'react-tooltip'

const QuestsBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-content: center;
  align-items: center;
`

const LevelQuests = ({
  label,
  count,
  quests,
  handleQuestClick,
  courseColor,
  shouldDisplayTargetDateIcon,
  shouldShowDate,
  courseSectionId,
  isUserEnrolled
}) => {
  const isActivityCourse = useIsActivityCourse(courseSectionId)
  // remap quest props based no progress - see util for note
  const updatedQuests = quests.map(updateQuestPropertiesFromProgress)
  const questItems = updatedQuests.map(q => {
    const isComplete =
      q.progress &&
      q.progress.quest_activities_count ===
        q.progress.activities_completed_count

    return (
      <FlexAlignCenter
        key={q.id}
        style={{
          justifyContent: 'space-between',
          cursor: 'pointer'
        }}
      >
        <QuestsBlock>
          <FlexAlignCenter style={{ width: '80%' }}>
            <LevelQuest
              key={`level-modal-quest-${q.id}`}
              quest={q}
              studentId={1}
              isUserEnrolled={isUserEnrolled}
              handleQuestClick={handleQuestClick}
              showFeedbackAvailable
              targetDate={q.targetDate}
              tooltipId={`level-modal-quest-tooltip-${q.level_id}`}
              courseSectionId={courseSectionId}
            />
            <H6QuestName
              onClick={() => handleQuestClick({ quest: q })}
            >
              {q.name}
            </H6QuestName>
          </FlexAlignCenter>
          <div style={{ width: '16%' }}>
            {q.targetDate && !isComplete && (
              <TargetDateIcon
                targetDate={q.targetDate}
                shouldShowDate={shouldShowDate}
                startAlign={true}
              />
            )}
          </div>
        </QuestsBlock>
      </FlexAlignCenter>
    )
  })

  const getTooltipContent = dataTip => {
    const quest = updatedQuests.find(q => q.id === parseInt(dataTip))

    return quest ? (
      <QuestTooltip
        quest={quest}
        unstarted={!quest.progress}
        awaitingFeedback={
          quest.progress &&
          quest.progress.awaiting_approval
        }
        feedbackKeepWorking={
          quest.progress &&
          quest.progress.current_activity_feedback_status ===
            'disapproved'
        }
        feedbackContinue={
          quest.progress &&
          quest.progress.current_activity_feedback_status ===
            'approved'
        }
        questComplete={
          quest.progress && quest.progress.completed_at
        }
        core={quest.required}
        progress={quest.progress}
        courseColor={courseColor}
        targetDate={quest.targetDate}
        shouldDisplayTargetDateIcon={shouldDisplayTargetDateIcon}
      />
    ) : null
  }

  return (
    <QuestsContainer>
      {!isActivityCourse && (
        <FlexAlignCenter
          style={{ justifyContent: 'space-between', marginBottom: '6px' }}
        >
          <CoreChoiceMarker>{label}</CoreChoiceMarker>
          <H5 dove>{`${count} Minimum`}</H5>
        </FlexAlignCenter>
      )}
      {questItems}

      <TooltipContainer>
        <ReactTooltip
          id={`level-modal-quest-tooltip-${quests[0]?.level_id}`}
          effect="solid"
          getContent={getTooltipContent}
        />
      </TooltipContainer>
    </QuestsContainer>
  )
}

LevelQuests.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  quests: PropTypes.array.isRequired,
  handleQuestClick: PropTypes.func.isRequired,
  courseColor: PropTypes.string.isRequired,
  targetDate: PropTypes.array,
  shouldDisplayTargetDateIcon: PropTypes.bool,
  shouldShowDate: PropTypes.bool
}

export default LevelQuests
